import React from "react";
import ReactDOM from "react-dom";
import { Toast } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Route,
  // Link,
  // useLocation
} from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import { DevTool } from "little-state-machine-devtools";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Result from "./components/Result";

import "./styles.css";

createStore({
  yourDetails: {
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    csvTable: [],
    csvTable_final1: [],
    csvTable_final2: [],
    csvTable_final3: [],
    csvTableErrors: [],
    csvTableMeta: [],
    csvTableSelectedCol_Customer_ID: "",
    csvTableSelectedCol_Order_Date: "",
    csvTableSelectedCol_Order_ID: "",
    csvTableSelectedCol_Sales: "",
    csvTableSelectedCol_City: "",
    csvTableSelectedCol_Industry: "",
    csvTableSelectedCol_Email: "",
    csvTableTextData: [],
    textCol: "",
    colOptions: [],
    userUploadShow: true,
    showTable: false,
    ShowTable_final: false,
  }
});

const Pages = () => {
  // const location = useLocation();
  return (
    <>
      {/* <nav className="container">
        <ul className="steps">
          <li className={location.pathname === "/" ? "active" : ""}>
            <Link to="/">Step 1</Link>
          </li>
          <li className={location.pathname === "/step2" ? "active" : ""}>
            <Link to="/step2">Step 2</Link>
          </li>
          <li className={location.pathname === "/result" ? "active" : ""}>
            <Link to="/result">Result</Link>
          </li>
        </ul>
      </nav> */}
      <Route exact path="/" component={Step1} />
      <Route path="/step2" component={Step2} />
      <Route path="/result" component={Result} />
    </>
  );
};

function App() {
  return (
    <StateMachineProvider>
      <DevTool />
      <div className="container">
        <div className="Header">
          <h1>Customer Segmentation<br></br> <span><i>Demo</i></span></h1>

        </div>
        <Router>
          <Pages />
        </Router>

      </div>
      <div className="contact-bubble">
        <Toast>
          {/* <Toast.Header>
            <strong className="mr-auto">AAARL</strong>
          </Toast.Header> */}
          <Toast.Body> <a href="https://www.aaarl.ca/contact" target="_blank">Contact Us</a> for Visualizations & Analysis</Toast.Body>
        </Toast>
      </div>
    </StateMachineProvider>
    
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
